import {Box, Dialog, DialogTitle, styled} from '@mui/material';

const StyledDialog = styled(Dialog)`
	max-width: 484px;
	margin: auto;

	& .MuiDialog-paper {
		margin: 16px;
	}

	${({theme}) => theme.breakpoints.up('sm')} {
		& .MuiDialog-paper {
			margin: 32px;
		}
	}
`;

const StyledCarouselContainer = styled(Box)`
	height: 100%;
	display: flex;
	flex-direction: column;

	#outer-container,
	#outer-container > #inner-container {
		flex: 1;
	}

	#outer-container > #inner-container,
	#outer-container > #inner-container > #slide-container {
		height: 100% !important;
	}

	#outer-container > #inner-container > #slide-container > div.slide {
		height: calc(100% - 32px);
		flex-basis: 100%;
	}

	#dots-container {
		margin-top: 16px;
		padding-inline: 11px;
	}
`;

const StyledDialogHeader = styled(DialogTitle)`
	padding: 16px 24px;
	background-color: ${({theme}) => theme.palette.primary.main};
	color: ${({theme}) => theme.palette.common.white};
`;

const ImageContainer = styled(Box)`
	margin: 16px auto 0px;
	width: fit-content;
`;

export {StyledDialog, StyledCarouselContainer, StyledDialogHeader, ImageContainer};
